import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const MESSAGES_MAX_DISPLAY_DURATION = 60000;
let nb_messages = 0;

interface Message {
  id: number;
  title: string;
  text: string;
  severity: string;
  created: number;
  open: boolean;
}
interface MessagesState {
  items: Array<Message>;
}
// Adds a message to the store
const createMessage = function (state: MessagesState, severity: string, title: string, text: string) {
  let message: Message = {
    id: nb_messages++,
    severity,
    title,
    text,
    created: Date.now(),
    open: true,
  };
  state.items.push(message);
  state.items = state.items.slice(0);
};
const initialState: MessagesState = {
  items: [],
};
const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    // Creates an error message
    error(state, action: PayloadAction<string>) {
      createMessage(state, "error", "", action.payload.replace("execution reverted: ", "").replace("ERC20: ", ""));
    },
    // Creates an information message
    info(state, action: PayloadAction<string>) {
      createMessage(state, "info", "Information", action.payload);
    },
    success(state, action: PayloadAction<string>) {
      createMessage(state, "success", "Success", action.payload);
    },
    // Closes a message
    close(state, action: PayloadAction<Message>) {
      state.items = state.items.map(message => {
        return message.id == action.payload.id ? Object.assign({}, message, { open: false }) : message;
      });
    },
    // Finds and removes obsolete messages
    handle_obsolete(state) {
      let activeMessages = state.items.filter(message => {
        return Date.now() - message.created < MESSAGES_MAX_DISPLAY_DURATION;
      });
      if (state.items.length != activeMessages.length) {
        state.items = activeMessages;
      }
    },
  },
});

export const { error, info, close, success, handle_obsolete } = messagesSlice.actions;

export default messagesSlice.reducer;
